"use strict"; // https://dom.spec.whatwg.org/#interface-nonelementparentnode
// getElementById is implemented separately inside Document and DocumentFragment.

var _classCallCheck = require("/Users/zacharialutz/projects/thinkful_EI/capstone-3/Group5-Capstone3-Client/node_modules/@babel/runtime/helpers/classCallCheck");

var NonElementParentNodeImpl = function NonElementParentNodeImpl() {
  _classCallCheck(this, NonElementParentNodeImpl);
};

module.exports = {
  implementation: NonElementParentNodeImpl
};